export default __webpack_public_path__ + "static/media/AssertivenessConnecting.7add5601.png";